// src/context/AuthContext.js
import React, { createContext, useState } from 'react';

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
    // 1. Inizializza leggendo dal browser (se c'è una sessione salvata)
    const [auth, setAuth] = useState(() => {
        const stored = localStorage.getItem('user_session');
        return stored ? JSON.parse(stored) : {};
    });

    // 2. Funzione LOGIN (Salva i dati)
    const login = (userData) => {
        const sessionData = {
            token: userData.token,
            user_id: userData.user_id,
            role: userData.user_role || userData.role || 'user', // Gestisce vari formati
            tenant_id: userData.tenant_id || null,
            tenant_name: userData.tenant_name || 'Unitest AI',
            tenant_logo: userData.tenant_logo || null,
            name: userData.name
        };
        setAuth(sessionData);
        localStorage.setItem('user_session', JSON.stringify(sessionData));
    };

    // 3. Funzione LOGOUT (Cancella i dati) <--- QUESTA MANCAVA O NON USATA
    const logout = () => {
        console.log("Eseguo Logout...");
        setAuth({}); // Pulisce lo stato React
        localStorage.removeItem('user_session'); // Pulisce la memoria del browser
        window.location.href = '/login'; // Forza il redirect e ricarica la pagina
    };

    return (
        <AuthContext.Provider value={{ auth, setAuth, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

export default AuthContext;